import { environment } from 'src/environments/environment';

export class Config {
  public static production: boolean = environment.production;
  public static apiUrl: string = environment.apiUrl;
  public static cdnUrl: string = environment.cdnUrl;
  public static imgCdnUrl: string = environment.imgCdnUrl;
  public static defLocale = environment.defaultLocale;
}

export class CloudConfig {
  public static cloudName = environment.cloudinaryName;
  public static cloudApiKey = environment.cloudinaryApiKey;
  public static cloudApiSecret = environment.cloudinaryApiSecret;
}

export class TequilaConfig {
  public static tequilaApiUrl = environment.tequilaApiUrl;
  public static tequilaApiKey = environment.tequilaApiKey;
}

export class RadarConfig {
  public static radarSecretKey = environment.radarSecretKey;
  public static radarLiveKey = environment.radarLiveKey;
}
